import { useEffect, useState } from 'react';
import useScreenSize from '../components/useScreenSize';
import { VERSION_UPDATE_EVENT, versionEventEmitter } from '../utils/api';
import AppInfo from '../../version.json';
import { Button } from '@mantine/core';
import { InfoIcon, ArrowClockwiseIcon } from "@phosphor-icons/react";

export function VersionUpdateNotification() {
    const [latestVersion, setLatestVersion] = useState<string | null>(null);
    const { isMedium } = useScreenSize();
    const currentVersion = AppInfo.version;

    useEffect(() => {
        const handleVersionUpdate = (event: Event) => {
            const customEvent = event as CustomEvent<string>;
            setLatestVersion(customEvent.detail);
        };

        versionEventEmitter.addEventListener(VERSION_UPDATE_EVENT, handleVersionUpdate);
        return () => {
            versionEventEmitter.removeEventListener(VERSION_UPDATE_EVENT, handleVersionUpdate);
        };
    }, [currentVersion]);

    if (!latestVersion || latestVersion === currentVersion) {
        return null;
    }

    const handleRefresh = () => {
        window.location.reload();
    };

    if (isMedium) {
        // Desktop version - bottom right corner
        return (
            <div style={{position: 'fixed', bottom: 35, right: 0, zIndex: 100, margin: '1rem'}}>
                <div style={{
                    backgroundColor: 'var(--mantine-color-dark-6)',
                    border: '1px solid var(--mantine-color-dark-4)',
                    borderRadius: 'var(--mantine-radius-sm)',
                    width: '25rem',
                    padding: '0.75rem',
                }}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.75rem'}}>
                        <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                            <InfoIcon size={20} color="var(--mantine-color-forge-5)" />
                            <span>
                                A new version ({latestVersion}) is available
                            </span>
                        </div>
                        <Button
                            leftSection={<ArrowClockwiseIcon size={16} />}
                            size="xs"
                            onClick={handleRefresh}
                        >
                            Refresh page
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    // Mobile version - full width, sticky above footer
    return (
        <div style={{position: 'sticky', bottom: 0, left: 0, right: 0, zIndex: 100}}>
            <div style={{
                backgroundColor: 'var(--mantine-color-dark-6)',
                borderTop: '1px solid var(--mantine-color-dark-4)',
                width: '100%',
                padding: '0.75rem',
            }}>
                <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.75rem'}}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '0.5rem'}}>
                        <InfoIcon size={20} color="var(--mantine-color-forge-5)" />
                        <span>
                            A new version ({latestVersion}) is available
                        </span>
                    </div>
                    <Button
                        leftSection={<ArrowClockwiseIcon size={16} />}
                        size="xs"
                        onClick={handleRefresh}
                    >
                        Refresh page
                    </Button>
                </div>
            </div>
        </div>
    );
}
